// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__oRjRx","logo":"Sidebar_logo__r90f+","active":"Sidebar_active__A6P5V","sidebar-icon":"Sidebar_sidebar-icon__1NXp9"};